import {apiUrl} from '@/constants/config';
import {client as http, axiosInstance} from '../../http_client';

export default {
    state: {
        reviews: {
            conf_applications: [],
            reg_applications: []
        }
    },
    getters: {
        reviews: state => state.reviews
    },
    mutations: {

    },
    actions: {
        getReviews({state}) {
            // return new Promise((resolve, reject) => {
            //     http.get('/applications/review/', {}).then(response => {
            //         state.reviews.applications = response.data;
            //         resolve(response.data);
            //     }, err => {
            //         console.log(err);
            //         reject(err.response.data);
            //     });
            // });

            return new Promise((resolve, reject) => {
                http.get('/review', {}).then(response => {
                    state.reviews = response.data;
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        }
    }
}
